module.exports = [
  {
    id: 1,
    title: "Company",
    menuList: [
      // { name: "About Us", routerPath: "/" },
      // { name: "Careers", routerPath: "/" },
      { name: "Blog", routerPath: "/blog" },
      { name: "Become a Travel Advisor", routerPath: "/contact" },
      // { name: "Gift Cards", routerPath: "/" },
    ],
  },
  {
    id: 2,
    title: "Support",
    menuList: [
      { name: "Contact", routerPath: "/contact" },
      { name: "Legal Notice", routerPath: "/legal-notice" },
      { name: "Privacy Policy", routerPath: "/privacy-policy" },
      { name: "Terms and Conditions", routerPath: "/terms-and-conditions" },
      { name: "Sitemap", routerPath: "/sitemap.xml" },
    ],
  },
  {
    id: 3,
    title: "Other Services",
    menuList: [
      { name: "Deals", routerPath: "/deals" },
      { name: "Transfer", routerPath: "https://www.book-online-transfers.com/en/veels-llc" },
    ],
  },
];
